import httpClient from '@/lib/httpClient.js'
import { useQuery } from '@tanstack/react-query'

/**
 * GET /team/saved-views?surface= — the current user's saved views for a
 * dashboard surface, plus `meta.team_defaults` (period_type, default_horizon,
 * week_starts_on): the fallback used when the user has no default view.
 */
export default function useGetSavedViews({ surface, enabled = true } = {}) {
  const fetchData = async () => {
    const response = await httpClient.get('team/saved-views', {
      params: { surface },
    })
    return response.data
  }

  return useQuery({
    queryKey: ['saved-views', { surface }],
    queryFn: fetchData,
    enabled: enabled && !!surface,
  })
}
